import React, {Component} from 'react'
/** OWN COMPONENTS **/
import UserInfo from './UserInfo/UserInfo'
/*** REDUX  ****/
import {connect} from 'react-redux'
/** REACT TOOLBOX ***/
import '../../../assets/react-toolbox/theme.css';
import theme from '../../../assets/react-toolbox/theme.js';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';
import FontIcon from 'react-toolbox/lib/font_icon/FontIcon'

class ViewAccount extends Component {

    render() {
        return (
            <ThemeProvider theme={theme}>
                <div className={'row variableHeight minus10PxMargin'}>
                    <div className={'row'} style={{'height': '20%'}}>
                        <div className=" col-xs-11">
                            <h3 className="ViewAccountHeader">
                                <FontIcon
                                    value={'account_circle'}
                                    style={{
                                        'fontSize': '40px',
                                        margin: '20px 10px 17px 0px',
                                    }}/>
                                <b>Manage Account</b></h3>
                        </div>
                    </div>
                    <UserInfo/>
                </div>
            </ThemeProvider>
        )
    }

}


const dashboardStateToProps = (state) => {
    return {
        isAdmin: state.user.admin
    }
};

export default connect(dashboardStateToProps, null)(ViewAccount)



// WEBPACK FOOTER //
// ./src/components/DashBoard/ViewAccount/ViewAccount.js